// import { mockSupplierOptions } from '@__mocks__';
import { ImageFile, MAX_IMAGE_SIZE } from '@utilities/types';

const imageValidatonRules = {
  validate: (value: ImageFile[]) => {

    if (value.length === 0) {
      return "Au moins une image est requise.";
    }

    // Validation pour chaque image dans le tableau
    for (const image of value) {

      if (image?.preview && !image?.file) {
        continue; // Mode édition, on passe à l'image suivante
      }

      if (!image?.preview) {
        return "Au moins une image est requise.";
      }

      if (image?.file && image?.file.size > MAX_IMAGE_SIZE) {
        return "L'image dépasse la taille maximale autorisée.";
      }

      const allowedFormats = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

      if (image?.file && !allowedFormats.includes(image?.file.type)) {
        return "Le format de l'image n'est pas autorisé. Formats valides : JPEG, PNG, GIF, WEBP.";
      }
    }

    // Si aucune des conditions d'erreur n'est rencontrée, la validation réussit
    return true;
  }
}


export const productFormValidationSchema = {
  // productImages: imageValidatonRules,

  name: {
    required: "Le nom du produit est obligatoire", // Le champ ne doit pas être vide
    minLength: {
      value: 3,
      message: "Le nom du produit doit comporter au moins 3 caractères"
    },
    maxLength: {
      value: 50,
      message: "Le nom du produit ne doit pas dépasser 50 caractères"
    },
    pattern: {
      value: /^[a-zA-Z0-9\s-]*$/,
      message: "Le nom du produit contient des caractères non autorisés.",
    }
  },

  category: {
    required: "La categorie est obligatoire" // Le champ ne doit pas être vide
  },
  // Règles pour le prix
  price: {
    // required: "Le prix est obligatoire",
    validate: (value: number) => {
      if (value <= 0) {
        return "Le prix doit être un nombre positif"; // Le prix doit être un nombre positif
      }
      return true; // Validation réussie si aucune erreur
    }
  },
  // Règles pour la description
  description: {
    required: "La description est obligatoire", // Le champ ne doit pas être vide
    maxLength: {
      value: 500,
      message: "La description ne doit pas dépasser 500 caractères" // Limitation de la longueur de la description
    }
  }
};

export const categoryFormValidationSchema = {
  name: {
    required: "Le nom de la catégorie est requis.", // Vérification que le champ n'est pas vide
    minLength: {
      value: 3,
      message: "Le nom doit comporter au moins 3 caractères.", // Longueur minimale de 3 caractères
    },
    maxLength: {
      value: 50,
      message: "Le nom ne doit pas dépasser 50 caractères.", // Longueur maximale de 50 caractères
    },
    pattern: {
      value: /^[a-zA-Z0-9\s-]*$/, // Caractères autorisés : lettres, chiffres, espaces et tirets
      message: "Le nom de la catégorie contient des caractères non autorisés.",
    }
  },
  // categoryImage: imageValidatonRules

}



const pTypeMock: { label: string, value: string }[] = [

  {
    label: "Hydratant",
    value: "moisturizer"
  },
  {
    label: "Sérum",
    value: "serum"
  },
  {
    label: "Nettoyantt",
    value: "cleaner"
  }
]


export const addProductFormFieldConfigs = [
  { label: 'Nom du produit', name: 'name', type: 'text', placeholder: 'Nom du Produit' },
  { label: 'Selectionner une catégories', name: '_categoryID', type: 'select', placeholder: 'Catégories', options: pTypeMock },
  { label: 'Prix de vente', name: 'price', type: 'number', placeholder: 'Prix' },
  { label: 'Description', name: 'description', type: 'textarea', placeholder: 'Description' },
];


export const supplyProductValidationRules = {
  quantity: {
    required: "La quantité est obligatoire.",
    min: {
      value: 1,
      message: "La quantité doit être supérieure à 0.",
    },
  },
  productPurchasePrice: {
    required: "Le prix d'achat est obligatoire.",
    min: {
      value: 0.01,
      message: "Le prix doit être supérieur à 0.",
    },
  },
  sellingPrice: {
    required: "Le prix de vente est obligatoire.",
    min: {
      value: 0.01,
      message: "Le prix doit être supérieur à 0.",
    },
  },
  _supplierID: {
    required: false,
    pattern: {
      value: /^[a-zA-Z0-9-]*$/,
      message: "L'ID du fournisseur contient des caractères non autorisés.",
    },
  },
};

export const updateProductStockFieldConfigs = [
  {
    name: 'quantity',
    type: 'number',
    placeholder: 'Quantité à approvisionner'
  },
  {
    name: 'productPurchasePrice',
    type: 'number',
    placeholder: 'Prix d\'achat unitaire'
  },
  {
    name: 'sellingPrice',
    type: 'number',
    placeholder: 'Prix de vente unitaire'
  },
  {
    name: '_supplierID',
    type: 'select',
    placeholder: 'ID du fournisseur (Optionnel)',
    // options: mockSupplierOptions
  }
];
